import {
    EventsNearYouCategoryBrowseExperiment,
    EventsNearYouCategoryBrowseValues,
    useGetStatsigEnrollment,
} from '@eventbrite/discover-utils';
import { LoadingSkeleton } from '@eventbrite/loading-skeleton';
import React from 'react';
import { FormattedLocationResponse } from '../../api';
import { CATEGORY_BROWSE_PLACEMENT } from '../../utils/analytics';
import { CategoryBrowseEvents } from '../CategoryBrowseEvents';
import {
    categoryRadiusMap,
    getNearbyEventsCarouselTitle,
} from './categoryDistanceUtils';
import { useLocationData } from './hooks';

interface CategoryDistanceCarouselProps {
    locationData?: FormattedLocationResponse;
    category: string;
    locationSlug: string;
    isMobile?: boolean;
}

export const CategoryDistanceCarousel = (
    props: CategoryDistanceCarouselProps,
) => {
    const isOnline = props.locationSlug === 'online';

    const eventsNearYouCategoryBrowseExperiment = useGetStatsigEnrollment({
        name: EventsNearYouCategoryBrowseExperiment.name,
        paramName: EventsNearYouCategoryBrowseExperiment.paramName,
        defaultValue: EventsNearYouCategoryBrowseExperiment.values.control,
        enabled:
            !isOnline &&
            !!props.locationData &&
            !!props.locationData.currentPlace,
    });

    const showEventsNearYouCarousel =
        eventsNearYouCategoryBrowseExperiment.variant ===
        EventsNearYouCategoryBrowseValues.test;

    const deviceLocation = useLocationData();

    const nearbyEventsCarouseltTitle = getNearbyEventsCarouselTitle(
        props.locationData,
        deviceLocation,
    );

    if (!showEventsNearYouCarousel) {
        return null;
    }

    return (
        <>
            {eventsNearYouCategoryBrowseExperiment.status === 'loading' ? (
                <LoadingSkeleton height={props.isMobile ? '417px' : '370px'} />
            ) : (
                eventsNearYouCategoryBrowseExperiment.variant ==
                    EventsNearYouCategoryBrowseValues.test && (
                    <CategoryBrowseEvents
                        queryOverload={{
                            point_radius: {
                                latitude: props.locationData?.latitude,
                                longitude: props.locationData?.longitude,
                                radius:
                                    categoryRadiusMap[props.category] || '5mi',
                            },
                            page_size: 8,
                            aggs: {},
                        }}
                        title={nearbyEventsCarouseltTitle}
                        bucketName={CATEGORY_BROWSE_PLACEMENT}
                        bucketKey="nearby_events"
                        bucketPosition="2"
                        includeHyperlinks={false}
                        data-testid="category-distance-events"
                    />
                )
            )}
        </>
    );
};

export default CategoryDistanceCarousel;
